import styled, { css } from 'styled-components';
import { Dialog } from '@material-ui/core';

export const StyledKakarikoDialog = styled(Dialog)`
  ${(props: { theme: any }) => {
    return css`
      background: var(--overlay-color);

      h2 {
        font-family: 'Source Sans Pro';
        font-size: 1.5rem;
        font-weight: 600;
      }

      .banner-bar {
        background: ${props.theme.primaryBase};
        background: var(--primary-base);
        color: ${props.theme.white};
        color: var(--white-full);
        font-size: 24px;
        line-height: 30px;
        margin: 10px -10px -10px;
        padding: 10px;
        text-align: center;
      }

      .title-wrapper {
        align-items: center;
        display: flex;
        flex-direction: row;
        font-size: 24px;
        font-weight: 600;
        justify-content: space-between;
        line-height: 30px;

        button {
          justify-self: 'flex-end';
        }
      }

      .row {
        display: flex;
        flex-direction: row;
      }

      .MuiDialog-paper {
        height: auto;
        max-height: 85vh;
        min-height: 250px;
        min-width: 450px;
        padding: 10px;
      }

      .MuiDialogTitle-root {
        button {
          position: absolute;
          right: 0;
          top: 0;
        }
      }

      .close {
        position: absolute;
        top: 0;
        right: 0;
      }

      .MuiDialogActions-root {
        column-gap: 10px;
        justify-content: flex-end;

        button {
          max-width: 150px;
          width: 50%;
        }
      }
    `;
  }}
`;
